import { Pipe, PipeTransform } from '@angular/core';
import { ResponsiveService } from '../../core/responsive.service';
const shortSmallScreen = 16;
const shortBigScreen = 30;
const mediumSmallScreen = 55;
const mediumBigScreen = 80;
@Pipe({
    name: 'shortTitle',
})
export class ShortTitlePipe implements PipeTransform {
    constructor(public responsiveService: ResponsiveService) { }
    transform(value: string, length?: number) {
        if (length) {
            if (value?.length > length) {
                return value.substring(0, length) + '...';
            }
            return value;
        }
        const max = this.responsiveService.isScreenSmall() ? shortSmallScreen : shortBigScreen;
        if (value?.length > max) {
            return value.substring(0, max) + '...';
        }
        return value;
    }
}

@Pipe({
    name: 'mediumTitle',
})
export class MediumTitlePipe implements PipeTransform {
    constructor(public responsiveService: ResponsiveService) { }
    transform(value: string) {
        const max = this.responsiveService.isScreenSmall() ? mediumSmallScreen : mediumBigScreen;
        if (value?.length > max) {
            return value.substring(0, max) + '...';
        }
        return value;
    }
}
